import moment from 'moment'

export const getValidShows = events =>
  events.filter(event => {
    const pullDownTime = moment.utc(event.date_time).add(1, 'hour').valueOf()
    return moment.utc().valueOf() <= pullDownTime
  })
